import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href?: string;
  className?: string;
  children?: React.ReactNode;
}
export function CTAButton({
  href = '#offer',
  className = '',
  children = '¡QUIERO MI COPIA DE LONCHERA REALISTA 15-MIN  AHORA!'
}: CTAButtonProps) {
  return <motion.a href={href} animate={{
    boxShadow: ['0px 0px 0px rgba(231,111,81,0)', '0px 0px 20px rgba(231,111,81,0.6)', '0px 0px 0px rgba(231,111,81,0)']
  }} transition={{
    duration: 2.5,
    repeat: Infinity
  }} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`${`inline-block bg-[#E76F51] text-white font-bold text-center py-4 px-8 rounded-full transition-colors hover:bg-[#d65d40] text-[18px] shadow-lg ${className}`} text-[13px] pt-[10px] pb-[10px] pl-[25px] pr-[25px]`} data-id="element-2">
      {children}
    </motion.a>;
}